// extracted by mini-css-extract-plugin
module.exports = {"scoring":"GradedSkills_scoring__Rskfy","lock":"GradedSkills_lock__9CxsF"};